import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import { validateEmail, validateSenha, CPFValido } from "../utils/Validator";
import { maskCPF, maskTelefone } from "../utils/Masker";
import axios from "axios";
import GrupoUsuarioFrame from './GrupoUsuarioFrame';

const { Item: ItemForm } = Form;

export default class UsuarioForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      registro: {},
    }
  }

  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado,
      }, () => {
        // this.refs.usu_cpf.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onChangeGrupo = event => {
    const { registro } = this.state;
    registro['ue_grupo'] = event.ue_grupo;
    this.setState(event);
  }

  onOK = () => {
    const { registro } = this.state;

    if ((!this.state.registro.usu_nome) || (this.state.registro.usu_nome === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Nome' });
      return;
    }
    if ((!this.state.registro.usu_email) || (this.state.registro.usu_email === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Email' });
      return;
    }
    if ((this.state.registro.usu_email) && (!validateEmail(this.state.registro.usu_email))) {
      Modal.warning({ title: 'Aviso!', content: 'Email inválido' });
      return;
    }

    if (this.state.registro.usu_cpf) {
      const PFJ = registro.usu_cpf ? registro.usu_cpf.replace(/[^\d]/g, '') : '';
      if (!CPFValido(PFJ)) {
        Modal.warning({ title: 'Aviso!', content: 'CPF Inválido', });
        return;
      }
    }

    if ((!this.state.registro.usu_senha) || (this.state.registro.usu_senha === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Senha' });
      return;
    }
    if (this.state.registro.usu_senha.length < 6) {
      Modal.warning({ title: 'Aviso!', content: 'A Senha deve conter 6 caracteres ou mais' });
      return;
    }
    if ((!this.state.registro.ue_grupo) || (this.state.registro.ue_grupo.key === '0') || (this.state.registro.ue_grupo.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Grupo', });
      return;
    }


    const reg = {
      ...this.state.registro,
      usu_cpf: this.state.registro.usu_cpf ? this.state.registro.usu_cpf.toUpperCase().replace(/[^A-Z0-9]/g, '') : '',
      ue_grupo: this.state.registro.ue_grupo.key,
    };

    // console.log('onOK: ', reg)
    // return;

    this.props.onSalvarClick(reg);
  };






  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { usu_idf, usu_cpf, usu_nome, usu_email, usu_fone, usu_senha, ue_vendedor, ue_acesso_sistema, ue_perc_comissao, ue_grupo, novoReg } = this.state.registro;

    // console.log('UsuarioForm.this.state: ', this.state);

    return (
      <Modal
        title={usu_idf ? "Edição de Usuário" : "Cadastro de Usuário"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"50%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>


            <Col xs={24} sm={12} className="camposEspacoDireita">
              <span>Nome</span>
              <InputForm
                type="text"
                id="usu_nome"
                ref="usu_nome"
                value={usu_nome}
                validator={value => Boolean(value)}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={12}  >
              <span>Email</span>
              <InputForm
                type="email"
                id="usu_email"
                ref="usu_email"
                value={usu_email}
                maxLength={100}
                validator={validateEmail}
                onChange={this.onChange}
                disabled={novoReg ? false : true}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>CPF</span>
              <InputForm
                type="text"
                id="usu_cpf"
                ref="usu_cpf"
                value={usu_cpf}
                masker={maskCPF}
                onChange={this.onChange}
              // disabled={novoReg ? false : true}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Telefone</span>
              <InputForm
                id="usu_fone"
                ref="usu_fone"
                value={usu_fone}
                maxLength={15}
                carregando masker={maskTelefone}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Senha</span>
              <InputForm
                type="password"
                id="usu_senha"
                ref="usu_senha"
                value={usu_senha}
                minLength={6}
                maxLength={10}
                validator={validateSenha}
                onChange={this.onChange}
                errorMessage="Senha Inválida"
                disabled={novoReg ? false : true}
              />
            </Col>

            <Col xs={24} sm={6} style={{ padding: 0, margin: 0, marginTop: -20 }}>
              <GrupoUsuarioFrame
                label="Grupo Usuário"
                id="ue_grupo"
                value={ue_grupo}
                width={"100%"}
                onChange={this.onChangeGrupo}
              />
            </Col>

            <Col xs={24} sm={12} style={{ padding: 0, margin: 0, marginTop: 0 }}>
              <InputForm
                type="checkbox"
                id="ue_acesso_sistema"
                ref="ue_acesso_sistema"
                onChange={this.onChange}
                value={ue_acesso_sistema}
              >
                Acesso ao Sistema
              </InputForm>
            </Col>

            <Col xs={24} sm={6} style={{ padding: 0, margin: 0, marginTop: 0 }}>
              <InputForm
                type="checkbox"
                id="ue_vendedor"
                ref="ue_vendedor"
                onChange={this.onChange}
                value={ue_vendedor}
              >
                Vendedor
              </InputForm>
            </Col>

            {ue_vendedor ? (
              <Col xs={24} sm={6} style={{ padding: 0, margin: 0, marginTop: -20 }}>
                <span>% Comissão</span>
                <InputForm
                  // type="text"
                  id="ue_perc_comissao"
                  ref="ue_perc_comissao"
                  value={ue_perc_comissao}
                  onChange={this.onChange}
                  type="number"
                />
              </Col>
            ) : null}
          </Row>

          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  type="primary"
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="btn-salvar"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UsuarioForm.js